export interface IBackofficesaleMaster {
    Id: number,
    InvoiceNo: string,
    VoucherNo: string,
    BranchID: number,
    CustomerID: number,
    RefNo: string,
    Remarks: string,
    InvoiceDate: Date,
    deliveryDate: Date,
    deliveryAddress: string,
    Amount: number,
    Rate: number,
    Discount: number,
    fright: number,
    VAT: number,
    deliverynoteno: string,
    VoucherType: number,
    salesmanID: number,
    SalesmanName: string,
    Pmode: number,
    UserId: number,
    Credit: number,
    Debit: number,
    TotalBfDiscount: number,
    Total: number,
    VatAcc: number,
    Transno: number,
    Status: number,
    Contact: ISalesContacts[],
    BackofficesalesDetails: IBackofficesaleDetails[],
    CreditSalesBasedonSalesOrder: boolean,
    LocId: number,
    IsApprovalRecord: boolean,
    SalesOrderNo: number,
    BOInvNoGenerateEnable: boolean,
    SkipDeliveryNote: boolean,
    CheckStockBeforeSave: boolean
}
export interface IBackofficesaleDetails {
    ID: number,
    Barcode: string,
    ItemName: string,
    Unit: string,
    Qty: number,
    Foc: number,
    SlNo: number,
    Amount: number,
    Rate: number,
    DiscAmt: number,
    NetAmt: number,
    DiscDist: number,
    FocDist: number,
    FreightDist: number,
    NetCost: number,
    SellPrice: number,
    AllowTran: boolean,
    TaxRate: number,
    DetailTax: number,
    SerialNumberDetails:ISerialNumberDetails[],
    IsSerialItem:boolean
}
export class Backofficesale_Model implements IBackofficesaleMaster {
    Id: number;
    InvoiceNo: string;
    VoucherNo: string;
    BranchID: number;
    CustomerID: number;
    RefNo: string;
    Remarks: string;
    InvoiceDate: Date;
    deliveryDate: Date;
    deliveryAddress: string;
    Amount: number;
    Rate: number;
    Discount: number;
    fright: number;
    VAT: number;
    deliverynoteno: string;
    VoucherType: number;
    salesmanID: number;
    SalesmanName: string;
    Pmode: number;
    UserId: number;
    Credit: number;
    Debit: number;
    TotalBfDiscount: number;
    Total: number;
    VatAcc: number;
    Transno: number;
    Status: number;
    Contact: ISalesContacts[]
    BackofficesalesDetails: IBackofficesaleDetails[];
    CreditSalesBasedonSalesOrder: boolean;
    LocId: number;
    IsApprovalRecord: boolean;
    SalesOrderNo: number;
    BOInvNoGenerateEnable: boolean;
    SkipDeliveryNote: boolean;
    CheckStockBeforeSave: boolean;

    constructor() {
        this.Id = 0;
        this.InvoiceNo = "";
        this.VoucherNo = "";
        this.BranchID = 0;
        this.CustomerID = 0;
        this.RefNo = "";
        this.Remarks = "";
        this.InvoiceDate = new Date;
        this.deliveryDate = new Date;
        this.deliveryAddress = "";
        this.Amount = 0;
        this.Rate = 0;
        this.Discount = 0;
        this.fright = 0;
        this.VAT = 0;
        this.deliverynoteno = "";
        this.VoucherType = 0;
        this.salesmanID = 0;
        this.SalesmanName = "";
        this.Pmode = 0;
        this.UserId = 0;
        this.Credit = 0;
        this.Debit = 0;
        this.TotalBfDiscount = 0;
        this.Total = 0;
        this.VatAcc = 0;
        this.Transno = 0;
        this.Status = 0;
        this.Contact = []
        this.BackofficesalesDetails = [];
        this.CreditSalesBasedonSalesOrder = false;
        this.LocId = 0;
        this.IsApprovalRecord = false;
        this.SalesOrderNo = 0;
        this.BOInvNoGenerateEnable = false;
        this.SkipDeliveryNote = false;
        this.CheckStockBeforeSave = false;
    }
}
export class BackofficesaleDetails_Model implements IBackofficesaleDetails {
    ID: number;
    SlNo: number;
    Barcode: string;
    ItemName: string;
    Unit: string;
    Qty: number;
    Foc: number;
    Amount: number;
    Rate: number;
    DiscAmt: number;
    NetAmt: number;
    DiscDist: number;
    FocDist: number;
    FreightDist: number;
    NetCost: number;
    SellPrice: number;
    AllowTran: boolean;
    TaxRate: 0;
    DetailTax: 0;
    SerialNumberDetails:ISerialNumberDetails[];
    IsSerialItem:boolean;
    constructor() {
        this.ID = 0;
        this.SlNo = 0;
        this.Barcode = "";
        this.ItemName = "";
        this.Unit = "";
        this.Qty = 0;
        this.Foc = 0;
        this.Amount = 0;
        this.Rate = 0;
        this.DiscAmt = 0;
        this.NetAmt = 0;
        this.DiscDist = 0;
        this.FocDist = 0;
        this.FreightDist = 0;
        this.NetCost = 0;
        this.SellPrice = 0;
        this.AllowTran = false
        this.TaxRate = 0;
        this.DetailTax = 0;
        this.SerialNumberDetails=[];
        this.IsSerialItem=false;
    }
}
export interface ISalesContacts {
    Id: number,
    Name: string
    Address: string
    PhoneNo: string
    Email: string
    Gender: number
    DOB: Date
    Nationality: string
    InvoiceNumber: string
    LocId: number,
    Type: number
}
export class Sales_contact__Model implements ISalesContacts {
    Id: number
    Name: string
    Address: string
    PhoneNo: string
    Email: string
    Gender: number
    DOB: Date
    Nationality: string
    InvoiceNumber: string
    LocId: number
    Type: number
    constructor() {
        this.Id = 0
        this.Name = ""
        this.Address = ""
        this.PhoneNo = ""
        this.Email = ""
        this.Gender = 0
        this.DOB = new Date
        this.Nationality = ""
        this.InvoiceNumber = ""
        this.LocId = 0
        this.Type = 1
    }
}

export interface ISerialNumberDetails {
    SlNo: number,
    SerialNo:string
}

export class SerialNumberDetails implements ISerialNumberDetails {
    SlNo: number
    SerialNo:string
    
    constructor() {
        this.SlNo = 0
        this.SerialNo = ""
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/interface/Backofficesale_Master.ts